import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingLayoutComponent } from "@modules/landing/landing-layout.component";
import { AuthComponent } from "@modules/auth/auth.component";
import {AdminLayoutComponent} from "@modules/admin/admin-layout.component";

const routes: Routes = [
  { path: '', redirectTo: 'auth/es', pathMatch: 'full' },
  { path: 'auth/:lang', component: AuthComponent, pathMatch: 'full' },
  /** Landing */
  {
    path: 'admin/:lang',
    component: AdminLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('./modules/admin/admin-layout.module').then((m) => m.AdminLayoutModule)
    }]
  },
  /** Landing */
  {
    path: 'landing/:lang',
    component: LandingLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('./modules/landing/landing-layout.module').then((m) => m.LandingLayoutModule)
    }]
  },
  { path: '**', redirectTo: 'auth/es', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
